module.exports = __webpack_public_path__ + "static/media/intesaLogo.7dba7758.png";